import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
// image

import logo from "../../icons/logo/logo_transparent_background.png";
import { useTranslation } from "react-i18next";
import { changeTemPwdService } from "../../services/UserServices";
import formatError from "../../services/FormatError";

import swal from "sweetalert";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [showPwd, setshowPwd] = useState(false);
  const [showNewPwd, setshowNewPwd] = useState(false);
  const { t } = useTranslation();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const onSubmit = (e) => {
    e.preventDefault();
    if (newPassword !== "" && confirmPassword !== "") {
      changeTemPwdService({
        password: newPassword,
        confirmpassword: confirmPassword,
      })
        .then((res) => {
          if (res.status === 200) {
            swal("Success", "Password changed successfully", "success");
            navigate("/login");
          }
        })
        .catch((error) => {
          formatError(error.response?.data?.error);
        });
    } else {
    }
  };
  return (
    <div className="authincation h-100 p-meddle">
      <div className="container h-100">
        {" "}
        <div className="row justify-content-center h-100 align-items-center">
          <div className="col-md-6">
            <div className="authincation-content">
              <div className="row no-gutters">
                <div className="col-xl-12">
                  <div className="auth-form">
                    <div className="text-center mb-3">
                      <Link to="/login">
                        <img
                          src={logo}
                          alt="appLogo"
                          style={{ width: "50px" }}
                          className="img-fluid mb-1"
                        />
                        <h3
                          style={{
                            fontSize: "30px",
                            fontWeight: "600",
                            verticalAlign: "middle",
                            color: "var(--secondary)",
                          }}
                        >
                          AMG Global
                        </h3>
                      </Link>
                    </div>
                    <h4 className="text-center mb-4 ">Change Password</h4>
                    <form onSubmit={(e) => onSubmit(e)}>
                      <div className="form-group">
                        <div className="mb-4">
                          <label className="form-label fw-semibold text-dark">
                            New Password
                          </label>
                          <div className="input-group">
                            <span
                              className="input-group-text bg-light border-end-0"
                              style={{
                                paddingLeft: "12px",
                                paddingRight: "8px",
                              }}
                            >
                              <i className="fa fa-lock text-muted"></i>
                            </span>
                            <input
                              type={showNewPwd ? "text" : "password"}
                              placeholder={t("loginPasswordPlaceholder")}
                              className="form-control border-0  bg-light"
                              style={{
                                height: "42px",
                                fontSize: "14px",
                                paddingLeft: "8px",
                                boxShadow: "none",
                              }}
                              value={newPassword}
                              onChange={(e) => setNewPassword(e.target.value)}
                            />
                            <span
                              className="input-group-text bg-light border-start-0"
                              style={{
                                cursor: "pointer",
                                paddingLeft: "8px",
                                paddingRight: "12px",
                              }}
                              onClick={() => setshowNewPwd(!showNewPwd)}
                            >
                              <i
                                className={`fa text-muted ${
                                  showNewPwd ? "fa-eye-slash" : "fa-eye"
                                }`}
                              ></i>
                            </span>
                          </div>
                        </div>
                        <div className="mb-4">
                          <label className="form-label fw-semibold text-dark">
                            Confirm Password
                          </label>
                          <div className="input-group">
                            <span
                              className="input-group-text bg-light border-end-0"
                              style={{
                                paddingLeft: "12px",
                                paddingRight: "8px",
                              }}
                            >
                              <i className="fa fa-lock text-muted"></i>
                            </span>
                            <input
                              type={showPwd ? "text" : "password"}
                              placeholder={t("loginPasswordPlaceholder")}
                              className="form-control border-0  bg-light"
                              style={{
                                height: "42px",
                                fontSize: "14px",
                                paddingLeft: "8px",
                                boxShadow: "none",
                              }}
                              value={confirmPassword}
                              onChange={(e) =>
                                setConfirmPassword(e.target.value)
                              }
                            />
                            <span
                              className="input-group-text bg-light border-start-0"
                              style={{
                                cursor: "pointer",
                                paddingLeft: "8px",
                                paddingRight: "12px",
                              }}
                              onClick={() => setshowPwd(!showPwd)}
                            >
                              <i
                                className={`fa text-muted ${
                                  showPwd ? "fa-eye-slash" : "fa-eye"
                                }`}
                              ></i>
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="text-center">
                        <button
                          type="submit"
                          className="btn btn-primary btn-block"
                        >
                          SUBMIT
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
